import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SentenceCasePipe } from './sentence-case/sentence-case.pipe';
import { ExtractPipe } from './extract.pipe';
import { FilterPipe } from './filter.pipe';
import { ToAutomationIdPipe } from './to-automation-id/to-automation-id.pipe';
import { IsEmptyPipe } from './is-empty/is-empty.pipe';
import { IsNotEmptyPipe } from './is-empty/is-not-empty.pipe';
import { ObjectSizePipe } from './object-size.pipe';
import { DistanceFromNowPipe } from './distance-from-now.pipe';
import { PluralizePipe } from './pluralize.pipe';
import { ParamsPipe } from './params.pipe';
import { BooleanIconPipe } from './boolean-icon.pipe';

@NgModule({
    declarations: [
        SentenceCasePipe,
        ExtractPipe,
        FilterPipe,
        ToAutomationIdPipe,
        IsEmptyPipe,
        IsNotEmptyPipe,
        ObjectSizePipe,
        DistanceFromNowPipe,
        PluralizePipe,
        ParamsPipe,
        BooleanIconPipe
    ],
    imports: [CommonModule],
    exports: [
        SentenceCasePipe,
        ExtractPipe,
        FilterPipe,
        ToAutomationIdPipe,
        IsEmptyPipe,
        IsNotEmptyPipe,
        ObjectSizePipe,
        DistanceFromNowPipe,
        PluralizePipe,
        ParamsPipe,
        BooleanIconPipe
    ]
})
export class PipeModule {}
